import { useAppSelector } from '@shared/lib/redux'

import { profileStore } from './profile.slice'

export const useProfile = () => {
  const profileState = useAppSelector(profileStore.selectors.selectProfile)
  return {
    ...profileState
  }
}
